import cn from 'classnames';
import './progress.styl';

interface Props {
    total: number;
    progress: number;
    className?: string;
}

export const Progress = ({ className, total, progress }: Props) => {
    return (
        <div className={cn('progress', className)}>
            <div className="progress-inner" style={{ width: `${(progress / total) * 100}%` }}></div>
        </div>
    );
};
